import React, { useEffect } from "react";
import styled from "styled-components";
import { colors } from "../../styles";
import Submarine from "./Submarine";
import Balance from "./Balance";
import Grid from "@material-ui/core/Grid";
import { useTranslation } from "react-i18next";
import { useStateContext } from "../../providers/StateProvider";
import { LANGUAGE_TYPES } from "../../constants/context";

interface Props {
  isHide: boolean;
  ballance: number | string;
  onChangeInstructed: (state: boolean) => Promise<boolean>;
  decoyVal: boolean;
  onChangedePrivatize: (state: boolean) => Promise<boolean>;
  privateVal: boolean;
  decrypt: () => void;
}

interface ContainerProps {
  isHide: boolean;
}

const BannerContainer = styled.div<ContainerProps>`
  width: 94%;
  margin: 0 auto;
  border-radius: 25px;
  padding: 2em;
  // min-height: 490px;
  backdrop-filter: blur(4px);
  margin-top: ${(props) => (props.isHide ? 0 : "250px")};
  transition: all 0.2s ease-in-out;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
`;
export const QuestionMark = styled.div`
  min-width: 24px;
  min-height: 24px;
  color: white;
  border-radius: 12px;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid white;
  margin: 0 20px;
  cursor: pointer;
  &:hover ~ .question {
    display: block;
  }
`;

const OutlineButton = styled.button`
  max-width: 272px;
  width: 100%;
  font-size: 18px;
  // font-family: "NexaDemo-Light";
  height: 54px;
  border-radius: 20px;
  border: 1px solid rgb(${colors.fontColor});
  color: rgb(${colors.fontColor});
  // background: linear-gradient(180deg, rgba(16,23,65,1) 0%, rgba(12,35,64,1) 100%);
  background: transparent;
  margin: 1em 0;
  transition: all 0.2s ease-out;
  text-align: center;

  @media (max-width: 550px) {
    width: 90%;
    font-size: 16px;
  }
  &:hover {
    box-shadow: 0 4px 8px 0 rgba(${colors.border});
    cursor: pointer;
    color: rgb(${colors.main});
    background: rgb(${colors.fontColor});
  }
`;

const BalanceText = styled.p`
  font-size: 20px;
  color: #fc0707;
  // opacity: 0.7;
  font-family: "Montserrat-SemiBold";
  margin: 3em 0 2em 0;
  text-align: center;
`;

const BermudaTopContainer: React.FC<Props> = ({
  isHide,
  ballance,
  decoyVal,
  privateVal,
  onChangedePrivatize,
  onChangeInstructed,
  decrypt,
}) => {
  const { t } = useTranslation();
  const { language, setShowTooltip, setIsRevealTooltip } = useStateContext();

  useEffect(() => {
    if (privateVal) {
      setIsRevealTooltip(true);
      setShowTooltip(true);
    } else {
      setIsRevealTooltip(false);
      setShowTooltip(false);
    }
  }, [privateVal]);

  return (
    <BannerContainer isHide={isHide}>
      <Balance ballance={privateVal ? ballance : t("Hidden")} />
      <BalanceText>
        <label style={{ color: "white", paddingLeft: "6px" }}>{`${t(
          "Attention"
        )}: `}</label>
        {` ${t("NotConductTransaction")} `}
        <a
          rel="noopener noreferrer"
          style={{
            color: "white",
            textDecoration: "underline",
            whiteSpace: "nowrap",
          }}
          href={
            language === LANGUAGE_TYPES.ENGLISH
              ? "https://www.docdroid.net/NjVTqin/eng-version-pdf"
              : "https://www.docdroid.net/72QmZI1/bv3manual132-cn-revision-1-pdf"
          }
          target="_blank"
        >
          {`${t("Mirror")}1`}
        </a>{" "}
        <a
          rel="noopener noreferrer"
          style={{
            color: "white",
            textDecoration: "underline",
            whiteSpace: "nowrap",
          }}
          href={
            language === LANGUAGE_TYPES.ENGLISH
              ? "https://tan-demetra-6.tiiny.site/"
              : "https://pdf.ac/B7Xnj"
          }
          target="_blank"
        >
          {`${t("Mirror")}2`}
        </a>{" "}
        <a
          rel="noopener noreferrer"
          style={{
            color: "white",
            textDecoration: "underline",
            whiteSpace: "nowrap",
          }}
          href={
            language === LANGUAGE_TYPES.ENGLISH
              ? "https://smallpdf.com/file#s=a5a033b7-5c34-4feb-b03b-8206f80528d8"
              : "https://smallpdf.com/file#s=990db2b3-3e8e-4188-ae6d-01eb0d544b73"
          }
          target="_blank"
        >
          {`${t("Mirror")}3`}
        </a>
        {`. ${t("UninformedActions")}`}
      </BalanceText>

      <Grid container>
        <Grid item lg={3} md={12} sm={12}>
          <Submarine
            text={t("DecoyMode")}
            onChangeInstructed={onChangeInstructed}
            decoyVal={!decoyVal}
          />
        </Grid>
        <Grid
          item
          md={12}
          sm={12}
          lg={6}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <OutlineButton onClick={(e) => decrypt()}>
            {t("Decrypt")}
          </OutlineButton>
        </Grid>
        <Grid item md={12} lg={3} sm={12}>
          <Submarine
            text={t("BalanceReveal")}
            onChangeInstructed={onChangedePrivatize}
            decoyVal={privateVal}
          />
        </Grid>
      </Grid>
    </BannerContainer>
  );
};

export default BermudaTopContainer;
